export function sortBySwissLocale(a: string, b: string): number {
  return a.localeCompare(b, 'de-CH', {
    sensitivity: 'base',
    numeric: true
  });
}
